export const translationDomain = 'dollar-cost-average';
